import React from 'react';
import styled from 'styled-components';

export interface ToggleButtonGroupProps {
  children: React.ReactNode;
  className?: string;
  width?: number | string;
  justifyContent?: 'start' | 'center' | 'end';
}

export const ToggleButtonGroup: React.FC<ToggleButtonGroupProps> = ({
  children,
  className,
  width = 'clamp(10rem, 30vw, 12.5rem)',
  justifyContent = 'end',
}) => {
  return (
    <StyledToggleButtonGroup 
      className={className} 
      $width={width} 
      $justifyContent={justifyContent}
    >
      {children}
    </StyledToggleButtonGroup>
  );
};

const StyledToggleButtonGroup = styled.div<{ 
  $width: number | string; 
  $justifyContent: string; 
}>`
  /* Fluid button group that adapts to available space */
  display: flex;
  align-items: center;
  gap: 0;

  /* Use clamp for fluid width scaling */
  width: ${({ $width }) => typeof $width === 'number' ? `${$width}px` : $width};
  justify-self: ${({ $justifyContent }) => $justifyContent};

  > button {
    /* Fluid sizing with relative units */
    min-height: 2.75rem;
    min-width: 0;
    padding: 0.625rem 1rem;
    flex: 1;
    font-size: 0.875rem;
    font-weight: ${({ theme }) => theme.fontWeights.semiBold};
    border: 1px solid ${({ theme }) => theme.colors.borderBase};

    /* Connected button styling */
    &:first-child {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right: none;
    }

    &:last-child {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }

    &:active {
      transform: scale(0.98);
      transition: transform 0.1s ease;
    }
  }
`;

ToggleButtonGroup.displayName = 'ToggleButtonGroup';